import domWrap from '../utils/domWrap';
import h from '../utils/htm';

export default async container => { // 'comp-data-tabs'
	const nav = container.querySelector(':scope > header > nav');

	[...container.querySelectorAll(':scope > inner-content')].forEach((tab,index) => {
		const 	sel = selCol([...tab.querySelectorAll('comp-row:not(:first-child)')]),
				firstRow = domWrap(tab.querySelector('comp-row:first-child')),
				button = domWrap(h('button class="text"',tab.querySelector(':scope > h4')?.textContent || '').Node);
		nav.appendChild(button);

		button.addEventListener('click',selectTab);

		sel(1);

		function selectTab(){
			button.setSelected();
			domWrap(tab).setSelected('expanded');
		}

		if(index === 0) selectTab();

		firstRow.innerHTML = h('comp-col')('comp-col class="selected"',h('div class="switch"',[...tab.querySelector('comp-row:first-child').querySelectorAll(':scope > :not(:first-child)')].reduce((html,cur) => {
			return html + h('h4', cur.querySelector('h4')?.textContent);
		},''))('div class="switch-sub"',[...tab.querySelector('comp-row:first-child').querySelectorAll(':scope > :not(:first-child)')].reduce((html,cur) => {
			return html + h('h6', cur.querySelector('h6')?.textContent);
		},'')));

		[...firstRow.querySelectorAll('.switch > *')].forEach( (sw,index) => {
			sw.addEventListener('click',() => {
				sel(index + 1);
				domWrap(sw).setSelected();
			});
		});

		domWrap(firstRow.querySelector('.switch > *:first-child')).setSelected();

	});

	function selCol(rows){
		return index => rows.forEach(row => domWrap([...row.childNodes].filter(({nodeType}) => nodeType === 1)[index]).setSelected());
	}
};